module.exports = __webpack_public_path__ + "web_static/img/left_white.d476ae8c.png";